import { createAction } from 'redux-actions';

export const getTags = createAction('GET_TAGS');
export const getTagsSuccess = createAction('GET_TAGS_SUCCESS');
export const getTagsFailure = createAction('GET_TAGS_FAILURE');

export const createTag = createAction('CREATE_TAG', (payload) => payload, (payload, metadata) => metadata);
export const createTagSuccess = createAction('CREATE_TAG_SUCCESS', (payload) => payload, (payload, metadata) => metadata);
export const createTagFailure = createAction('CREATE_TAG_FAILURE');

export const batchTags = createAction('BATCH_TAGS', (payload) => payload, (payload, metadata) => metadata);
export const batchTagsSuccess = createAction('BATCH_TAGS_SUCCESS', (payload) => payload, (payload, metadata) => metadata);
export const batchTagsFailure = createAction('BATCH_TAGS_FAILURE');

export const updateTag = createAction('UPDATE_TAG', (payload) => payload, (payload, metadata) => metadata);
export const updateTagSuccess = createAction('UPDATE_TAG_SUCCESS');
export const updateTagFailure = createAction('UPDATE_TAG_FAILURE');

export const deleteTag = createAction('DELETE_TAG', (payload) => payload, (payload, metadata) => metadata);
export const deleteTagSuccess = createAction('DELETE_TAG_SUCCESS');
export const deleteTagFailure = createAction('DELETE_TAG_FAILURE');

